import React from 'react'
import Projects from './Projects'
import TechStack from './TechStack'

function Main() {
  return (
    <main>
      <section className="container mt-8">
        <Projects />
      </section>
      <section className="container mt-6">
        <TechStack />
      </section>
    </main>
  )
}

export default Main
